// extracted by mini-css-extract-plugin
module.exports = {"highlight_mention":"highlight_mention-r4kmJ","email_only":"email_only-zCZGl","yourself":"yourself-yZa6P","email_only_prefix":"email_only_prefix-B1c_Q"};